import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  pcFlag: 'PC', //是web端还是移动端
  languages: 'CN', //语言 ()
  clientHeight: 0
}
const getters = {
  getStoreFlag (state) {
    return state.pcFlag
  },
  getStoreLang (state) {
    return state.languages
  },
  getClientHeight (state) {
    return state.clientHeight
  }
}
const mutations = {
  storeFlag (state, flag) {
    state.pcFlag = flag
  },
  storeLang (state, language){
    state.languages = language
  },
  storeClientHeight (state, clientHeight){
    state.clientHeight = clientHeight
  }
}
const actions = {
  setStoreFlag ({commit}, flag) {
    commit('storeFlag', flag)
  },
  setStoreLang ({commit}, language) {
    commit('storeLang', language)
  },
  setStoreClientHeight({commit}, clientHeight) {
    commit('storeClientHeight', clientHeight)
  }
}
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js